import ApiService from './api';

// 商户（店铺）摘要
export interface MerchantSummary {
  id: string;
  business_name?: string;
  name?: string;
  mode?: string;
  status?: string;
  country?: string;
}

export class MerchantService {
  /**
   * 获取当前账号下的店铺列表
   * GET /merchant/list
   * 注意：后端该接口当前可能返回 500（已知问题），调用方需自行兜底。
   */
  static async listMerchants(): Promise<MerchantSummary[]> {
    const response = await ApiService.get<MerchantSummary[]>('/merchant/list');
    return Array.isArray(response.data) ? response.data : [];
  }

  /**
   * 切换当前店铺，后端返回新 token（含新的 merchant_id）
   * POST /merchant/switch/:id
   */
  static async switchMerchant(id: string): Promise<{ access_token?: string; token?: string } | any> {
    const response = await ApiService.post(`/merchant/switch/${id}`, {});
    return response.data;
  }
}

export default MerchantService;
